<button
  type="button"
  class="custom-tooltip"
  [class.custom-tooltip--open]="isOpen && shouldShowTooltip"
  #trigger
  (mouseenter)="openTooltip()"
  (mouseleave)="closeTooltip()"
  (focus)="openTooltip()"
  (blur)="closeTooltip()"
>
  <span class="custom-tooltip__text">{{ displayText }}</span>

  @if (isOpen && shouldShowTooltip) {
    <span
      #bubble
      class="custom-tooltip__bubble"
      [class.custom-tooltip__bubble--structured]="tooltipRows.length > 0"
      role="tooltip"
      [class.custom-tooltip__bubble--above]="tooltipPlacement === 'above'"
      [class.custom-tooltip__bubble--below]="tooltipPlacement === 'below'"
      [style.top.px]="tooltipPosition.top"
      [style.left.px]="tooltipPosition.left"
      [style.--tooltip-arrow-left.px]="tooltipPosition.arrowLeft"
    >
      @if (tooltipRows.length > 0) {
        <span class="custom-tooltip__rows">
          @for (row of tooltipRows; track $index) {
            <span class="custom-tooltip__row">
              <span class="custom-tooltip__label">{{ row.label }}</span>
              @if (row.value) {
                <span class="custom-tooltip__value">{{ row.value }}</span>
              }
            </span>
          }
        </span>
      } @else {
        {{ tooltipContent }}
      }
    </span>
  }
</button>
